import styled from 'styled-components';
import React from 'react';

const ExplainFeatures = styled.section`
  width: 100%;
  margin: 50px auto 80px auto;
  padding: 100px 0;
  background:
    radial-gradient(circle at 15% 10%, rgba(46, 180, 241, 0.14), transparent 45%),
    linear-gradient(160deg, var(--color-brand) 0%, var(--color-brand-deep) 100%);

  @media screen and (max-width: 768px) {
    width: 100%;
    padding: 4rem 1.5rem;
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;

  @media screen and (max-width: 768px) {
    padding: 0;
  }
`;

const Header = styled.div`
  text-align: center;
  max-width: 560px;
  margin: 0 auto 4rem;
`;

const Eyebrow = styled.p`
  font-family: var(--font-body);
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--color-accent-soft);
  margin-bottom: 1rem;
`;

const Title = styled.h2`
  font-family: var(--font-display);
  font-size: clamp(1.9rem, 3.4vw, 2.5rem);
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 1rem;
  color: var(--color-white);

  span {
    color: var(--color-accent-soft);
  }
`;

const Subtitle = styled.p`
  font-family: var(--font-body);
  font-size: 1.05rem;
  color: rgba(255, 255, 255, 0.75);
  line-height: 1.5;
`;

const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;

  @media screen and (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 2rem 1.75rem;
  border-radius: var(--radius-md);
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(6px);
  transition: transform 0.3s ease, background 0.3s ease, border-color 0.3s ease;

  &:hover {
    transform: translateY(-6px);
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.3);
  }
`;

const IconBadge = styled.div`
  width: 52px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-sm);
  background: rgba(255, 255, 255, 0.92);
  margin-bottom: 1.5rem;
`;

const CardIcon = styled.img`
  width: 26px;
  height: 26px;
`;

const CardTitle = styled.h3`
  font-family: var(--font-display);
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--color-white);
  margin-bottom: 0.6rem;
`;

const CardDescription = styled.p`
  font-family: var(--font-body);
  font-size: 0.95rem;
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.7);
`;

const items = [
  { icon: '/images/business.png', alt: 'Ícone de controle de múltiplas unidades', title: 'Controle múltiplas unidades', description: 'Controle todas as unidades em um só lugar e cresça sem complicações.' },
  { icon: '/images/cash-box.png', alt: 'Ícone de pedidos organizados', title: 'Pedidos organizados', description: 'Pedidos mais organizados e servidos mais rápido, garantindo clientes satisfeitos e mais vendas.' },
  { icon: '/images/checklist.png', alt: 'Ícone de cardápio digital', title: 'Cardápio virtual', description: 'Cardápio virtual em segundos, controle custos e garanta lucros, sem frustrações e nem desperdícios.' },
  { icon: '/images/digital-menu.png', alt: 'Ícone de controle de mesas', title: 'Controle de mesas', description: 'Controle mesas e reservas em tempo real, faturando mais com menos esforço.' },
  { icon: '/images/food.png', alt: 'Ícone de controle financeiro', title: 'Controle financeiro', description: 'Controle o caixa com precisão, evite fraudes e tome decisões financeiras com segurança.' },
  { icon: '/images/group.png', alt: 'Ícone de gestão de equipe', title: 'Gestão de equipe', description: 'Controle sua equipe e reduza erros com treinamento rápido e um ambiente de trabalho mais seguro.' },
  { icon: '/images/phone-messages.png', alt: 'Ícone de promoções inteligentes', title: 'Promoções inteligentes', description: 'Crie promoções personalizadas e transforme seus clientes em fãs do seu negócio.' },
  { icon: '/images/review.png', alt: 'Ícone de avaliação integrada', title: 'Avaliação integrada', description: 'Entenda o que seus clientes pensam com avaliações práticas e diretas disponíveis no sistema.' },
  { icon: '/images/table.png', alt: 'Ícone de segurança total', title: 'Segurança total', description: 'Acompanhe tudo o que acontece no sistema e mantenha seu negócio seguro.' },
];

const PainList = () => {

  return (
    <ExplainFeatures id="explain-features">
      <Container>
        <Header>
          <Eyebrow>O que você ganha</Eyebrow>
          <Title>E o que o <span>SofChef</span> vai te entregar</Title>
          <Subtitle>
            Acabe com todas as situações que te fazem render menos com as nossas soluções.
          </Subtitle>
        </Header>

        <CardGrid>
          {items.map((item) => (
            <Card key={item.title}>
              <IconBadge>
                <CardIcon src={item.icon} alt={item.alt} />
              </IconBadge>
              <CardTitle>{item.title}</CardTitle>
              <CardDescription>{item.description}</CardDescription>
            </Card>
          ))}
        </CardGrid>
      </Container>
    </ExplainFeatures>
  );
};

export default PainList;
